import { useState, useEffect } from 'react';
import {
  hasNoCovers,
  networkDirectory,
  networkMap,
} from '../../utils/networkMap';

import { INetwork, IOffer } from '../../utils/models';

export enum UseNetworkOptions {
  isPoster = 1,
}

interface IAddNetworkButton {
  buttonText: string;
  buttonLink: string;
}

// These networks have special promotional pages
// A "Add Network" button will be shown in the hero banner for these networks
const specialNetworks = {
  'MGM+': 'https://www.spectrum.com/cable-tv/premium-channels/mgmplus?cmp=sod',
  Cinemax: 'https://www.spectrum.com/premium-channels/cinemax.html?cmp=sod',
  Max: 'https://www.spectrum.com/premium-channels/hbo?cmp=sod',
  Showtime: 'https://www.spectrum.com/premium-channels/showtime?cmp=sod',
  STARZ: 'https://www.spectrum.com/premium-channels/starz?cmp=sod',
  'STARZ ENCORE':
    'https://www.spectrum.com/premium-channels/starz-encore?cmp=sod',
};

const useNetwork = (offer: IOffer | null, network?: INetwork) => {
  const [addNetworkButton, setAddNetworkButton] = useState<IAddNetworkButton>({
    buttonText: '',
    buttonLink: '',
  });

  // Determines if the "Add Network" button should be shown on the Hero Banner
  useEffect(() => {
    const { displayName } = network || {};
    if (displayName && specialNetworks[displayName]) {
      setAddNetworkButton({
        buttonText: `Add ${displayName}`,
        buttonLink: specialNetworks[displayName],
      });
    }
  }, [network]);

  const { providerName = '', providerId = '' } = network || offer || {};

  let targetNetwork = networkMap[networkDirectory[providerName]];

  if (/LCharter/.test(providerName)) {
    let targetProviderName = '';
    switch (providerId) {
      case 'sho.com':
        targetProviderName = 'SHOWTIME_HD_EXP';
        break;
      case 'hbo.com':
        targetProviderName = 'HBO_HD_EXP';
        break;
      case 'epixhd.com':
        targetProviderName = 'EPIX_HD';
        break;
      default:
        targetProviderName = '';
    }

    if (targetProviderName) {
      targetNetwork = networkMap[networkDirectory[targetProviderName]];
    }
  }

  const { networkImgUrl, price } = offer || {};

  // Network Logo
  const networkImagePath = price?.value
    ? 'https://cdnimg.spectrum.net/imageserver/image/default?providerId=IND_HD&productId=MOD' // Use Spectrum logo for rentals
    : targetNetwork?.networkImgUrl || networkImgUrl;
  const networkDisplayName = targetNetwork?.displayName || 'Network';
  const shouldShowNetworkImage =
    !hasNoCovers.includes(targetNetwork?.providerId) && networkImagePath;

  return {
    network,
    networkImagePath,
    networkDisplayName,
    shouldShowNetworkImage,
    addNetworkButton,
  };
};

export { useNetwork };
